const paymentMethods = {};

export const registerPaymentMethod = (paymentMethod) => {
    paymentMethods[paymentMethod.id] = paymentMethod;
}

export const getPaymentMethods = () => paymentMethods;

export const getPaymentMethod = (id) => paymentMethods[id] ? paymentMethods[id] : null;